/**
 * Depending on which select-options is selected
 * another field is been shown/hidden
 */
export default class FormSelectDependency {
  /**
   * constructor
   * @param {Object} [config] - optional/additional parameters
   */
  constructor(config = {}) {
    this.config = {
      selector: {
        trigger: '[data-form-dependency]',
      },
      modifier: {
        hidden: 'form__hidden',
      },
      ...config,
    };
    this.trigger = document.querySelectorAll(this.config.selector.trigger);
    if (!this.trigger.length) {
      return;
    }
    this.hideElements();
    this.bindEvents();
  }

  /**
   * hide target elements initially
   */
  hideElements() {
    this.trigger.forEach((option) => {
      const parentForm = option.closest('form');
      const elementHide = parentForm.querySelector(`[name="${option.dataset.formDependency}"]`);
      elementHide.classList.add(this.config.modifier.hidden);
    });
  }

  /**
   * bind events to select fields change
   */
  bindEvents() {
    this.trigger.forEach((option) => {
      const parentSelect = option.closest('select');
      parentSelect.addEventListener('change', (event) => {
        this.handleFieldVisibility(event);
      });
    });
  }

  /**
   * shows/hides target element depending on selected option
   * and inherits the "required"-attribute if the select is required.
   * @param {Event} event - onChange event
   */
  handleFieldVisibility(event) {
    const { target } = event;
    const currentOption = target.querySelector(`option[value="${target.value}"]`);
    const isTrigger = currentOption.dataset.formDependency;
    const parentForm = target.closest('form');
    const trigger = target.querySelector(this.config.selector.trigger);
    const elementShowSelector = trigger.dataset.formDependency;
    const elementShow = parentForm.querySelector(`[name="${elementShowSelector}"]`);
    if (isTrigger) {
      const { required } = target.attributes;
      if (required) {
        elementShow.setAttribute('required', true);
      }
      elementShow.classList.remove(this.config.modifier.hidden);
    } else {
      elementShow.setAttribute('required', false);
      elementShow.classList.add(this.config.modifier.hidden);
    }
  }
}
